import React, { useEffect, useMemo } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Chart from 'chart.js';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import Timeline from 'app/components/election/Timeline';

const useStyles = makeStyles(theme => ({
    section: {
        padding: theme.spacing(3)
    },
    canvasContainer: {
        position: 'relative',
        width: '100%',
    },
    container: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    marginBottom: {
        marginBottom: theme.spacing(3)
    },
    textCenter: {
        textAlign: 'center'
    }
}));

let ctx = null;
let barGraph = null;

export default function General(props) {

    const {
        election,
    } = props;

    const classes = useStyles();
    const theme = useTheme();

    /*
    useEffect(() => {

        if (election.proposals.length > 0 &&
            (election.recommendations_active || election.voting_active)
        ) {
            const chartConfig = {
                type: 'bar',
                data: {
                    labels: election.proposals.map(p => p.title),
                    datasets: []
                },
                options: {
                    scales: {
                      yAxes: [{
                        beginAtZero: true,
                        ticks: {
                            precision: 0
                        }
                      }]
                    }
                  },
            };

            if (election.recommendations_active) {
                chartConfig.data.datasets.push(
                    {
                        data: election.proposals.map(p => p.recommendations_count),
                        hoverOffset: 10,
                        backgroundColor: theme.palette.secondary.light,
                        label: 'Recommendations'
                    }
                )
            }

            if (election.voting_active) {
                chartConfig.data.datasets.push(
                    {
                        data: election.proposals.map(p => p.votes_count),
                        hoverOffset: 10,
                        backgroundColor: theme.palette.secondary.dark,
                        label: 'Votes'
                    }
                )
            }

            ctx = document.getElementById('barGraph').getContext("2d");
            barGraph = new Chart(ctx, chartConfig);
        }
    }, []);
    */

    return (
        <div className={classes.section}>
            <Grid
                container
                spacing={3}
                className={classes.marginBottom}
                >
                <Grid item xs={4} className={classes.textCenter}>
                    <Typography variant="h2" color="secondary" gutterBottom>
                        {election.total_proposals}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                        Total Proposals
                    </Typography>
                </Grid>
                <Grid item xs={4} className={classes.textCenter}>
                    <Typography variant="h2" color="secondary" gutterBottom>
                        {election.total_recommendations}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                        Total Recommendations
                    </Typography>
                </Grid>
                <Grid item xs={4} className={classes.textCenter}>
                    <Typography variant="h2" color="secondary" gutterBottom>
                        {election.total_votes}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                        Total Votes
                    </Typography>
                </Grid>
            </Grid>
            <Divider className={classes.marginBottom} />
            <div className={classes.marginBottom}>
                <Timeline election={election}/>
            </div>
        </div>
    );
}
